import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'editor',
  setup(__props) {

const content = ref('')

return (_ctx: any,_cache: any) => {
  const _component_u_editor = _resolveComponent("u-editor")!

  return (_openBlock(), _createBlock(_component_u_editor, {
    modelValue: content.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
    placeholder: "请输入内容"
  }, null, 8, ["modelValue"]))
}
}

})